<div class="order-partial-error-page">
  <main class="error-main">
    <div class="error-content">
      <div class="error-icon-container">
        <div class="error-icon">
          <span class="mdn-Icon-circulo-exclamacao mdn-Icon--lg" [attr.aria-label]="'pages.orderPartialError.iconAlt' | i18n"></span>
        </div>
      </div>

      <h1 class="error-title">{{ 'pages.orderPartialError.title' | i18n }}</h1>

      <!-- <div class="error-message">
        <p class="reason-label" *ngIf="data?.backendErrorMessage">
          {{ 'pages.orderPartialError.reasonLabel' | i18n }} {{ data?.backendErrorMessage }}
        </p>
        <p class="reason-label" *ngIf="data && !data.backendErrorMessage">
          {{ 'pages.orderPartialError.reasonLabel' | i18n }} {{ 'pages.orderPartialError.reasonUnknown' | i18n }}
        </p>
      </div> -->

      <div class="failed-products" *ngIf="data?.failedProducts?.length">
        <h2 class="failed-products-title">{{ 'pages.orderPartialError.failedProductsTitle' | i18n }}</h2>
        <ul class="failed-products-list">
          <li *ngFor="let item of (data?.failedProducts ?? []); trackBy: trackByIndex" class="failed-product-item">
            <span class="product-name">{{ item.name }}</span>
            <span class="product-qty">{{ 'pages.orderPartialError.quantity' | i18n }}: {{ item.quantity }}</span>
          </li>
        </ul>
      </div>

      <div class="action-buttons">
        <ustore-button
          [text]="'pages.orderPartialError.backToCart' | i18n"
          [format]="'filled'"
          [backgroundColor]="'var(--color-red-500-to-yellow)'"
          [textColor]="'var(--color-inverted)'"
          [size]="'medium'"
          [rounded]="'default'"
          (click)="goToCheckout()"
          class="primary-button">
        </ustore-button>
        <ustore-button
          [text]="'pages.orderPartialError.goToMyOrders' | i18n"
          [format]="'outlined'"
          [size]="'medium'"
          [rounded]="'default'"
          (click)="goToMyOrders()"
          class="secondary-button">
        </ustore-button>
        <ustore-button
          [text]="'pages.orderPartialError.goHome' | i18n"
          [format]="'outlined'"
          [size]="'medium'"
          [rounded]="'default'"
          (click)="goToHome()"
          class="secondary-button">
        </ustore-button>
      </div>
    </div>
  </main>
</div>
